export default "__VITE_ASSET__21702a1d__"